import loadingAnimation from '@common/assets/lottie/button_loading.json';
import { Icon } from '@common/index';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import Lottie from 'lottie-react';
import React, { useState } from 'react';
import styles from './styles.module.scss';

interface ShopifyStore {
    storeUrl: string;
    storeToken: string;
}

interface AccountListProps {
    stores: ShopifyStore[];
    onStoreSelect?: (store: ShopifyStore) => void;
    onConnectAnother?: () => void;
}

const AccountList: React.FC<AccountListProps> = ({
    stores,
    onStoreSelect,
    onConnectAnother
}) => {
    const [loadingStore, setLoadingStore] = useState<ShopifyStore | null>(null);
    const handleStoreClick = (store: ShopifyStore) => {
        setLoadingStore(store);
        onStoreSelect?.(store);
    };

    const handleConnectAnother = () => {
        onConnectAnother?.();
    };

    return (
        <div className={styles.accountListContainer}>
            <div className={styles.accountListHeader}>
                <div className={styles.iconContainer}>
                    <Icon name="shopify" size={50} />
                </div>
                <div className={styles.titleSection}>
                    <h2 className={styles.title}>Choose a Shopify store</h2>
                    <h3 className={styles.title}>to continue</h3>
                </div>
            </div>

            <div className={styles.storesSection}>
                <h4 className={styles.sectionTitle}>Your Connected Stores</h4>
                
                <div className={styles.storesList}>
                    {stores.map((store) => (
                        <div 
                            key={store.storeUrl}
                            className={styles.storeCard}
                            onClick={() => handleStoreClick(store)}
                        >
                            <div className={styles.storeInfo}>
                                <span className={styles.storeLabel}>Store URL:</span>
                                <span className={styles.storeUrl}>{store.storeUrl}</span>
                            </div>
                            {loadingStore?.storeUrl === store.storeUrl ? (
                                <div className={styles.loadingIndicator}>
                                    <Lottie 
                                        animationData={loadingAnimation} 
                                        style={{filter: 'var(--lottie-filter)'}}
                                    />
                                </div>
                            ) : (
                                <div className={styles.storeArrow}>
                                    <ChevronRightIcon width={20} height={20} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <button 
                    className={styles.connectAnotherButton}
                    onClick={handleConnectAnother}
                >
                    Connect another Shopify store
                </button>
            </div>
        </div>
    );
};

export default AccountList;
export type { AccountListProps, ShopifyStore };
